  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function typeIn(col) {
      if (!col || reduce) return;
      var els = col.querySelectorAll('.cx-casc__a1, .cx-casc__a2, .cx-casc__a3, .cx-casc__head span');
      els.forEach(function (el, n) {
        if (!el.dataset.split) {
          el.dataset.split = '1';
          if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', el.textContent.trim());
          Array.prototype.slice.call(el.childNodes).forEach(function (node) {
            if (node.nodeType !== 3 || !node.nodeValue.trim()) return;
            var w = document.createElement('span'), k = 0;
            w.setAttribute('aria-hidden', 'true');
            node.nodeValue.trim().split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { w.appendChild(document.createTextNode(' ')); k++; return; }
              var wd = document.createElement('span'); wd.className = 'cx-wd';
              part.split('').forEach(function (c) { var sp = document.createElement('span'); sp.className = 'cx-ch'; sp.textContent = c; sp.dataset.k = k++; wd.appendChild(sp); });
              w.appendChild(wd);
            });
            el.replaceChild(w, node);
          });
        }
        var base = Math.min(n, 16) * 32;
        el.querySelectorAll('.cx-ch').forEach(function (sp) { sp.style.setProperty('--d', (base + Math.min(+sp.dataset.k, 26) * 16) + 'ms'); });
      });
      col.classList.remove('is-typing'); void col.offsetWidth; col.classList.add('is-typing');
    }
    document.querySelectorAll('[data-cx-casc]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var c2 = box.querySelector('[data-cx-c2col]');
      var c3 = box.querySelector('[data-cx-c3col]');
      var t1;
      function show2(li) {
        c2.querySelectorAll('[data-cx-c2]').forEach(function (x) { x.classList.toggle('is-active', x === li); });
        var tpl = li ? li.querySelector('template') : null;
        c3.innerHTML = tpl ? tpl.innerHTML : '';
        c3.scrollTop = 0;
        if (tpl) typeIn(c3);
      }
      function show1(i) {
        box.querySelectorAll('[data-cx-c1]').forEach(function (li) { li.classList.toggle('is-active', li.getAttribute('data-cx-c1') === String(i)); });
        var d = box.querySelector('[data-cx-d1="' + i + '"]');
        c2.innerHTML = d ? d.innerHTML : '';
        c2.scrollTop = 0;
        show2(null);
        typeIn(c2);
      }
      function onEnter(e) {
        var a = e.target.closest('[data-cx-c1]');
        if (a && box.contains(a)) {
          clearTimeout(t1);
          t1 = setTimeout(function () { if (!a.classList.contains('is-active') || !c2.innerHTML) show1(a.getAttribute('data-cx-c1')); }, e.type === 'focusin' ? 0 : 70);
          return;
        }
        var b = e.target.closest('[data-cx-c2]');
        if (b && c2.contains(b) && !b.classList.contains('is-active')) show2(b);
      }
      box.addEventListener('mouseover', onEnter);
      box.addEventListener('focusin', onEnter);
      show1(0);
      var item = box.closest('[data-cx-drop]');
      var tab = box.querySelector('[data-cx-casc-tab]');
      function placeTab() {
        var btn = item.querySelector('.cx-nav__link');
        if (!btn || !tab) return;
        var b = btn.getBoundingClientRect(), p = box.getBoundingClientRect();
        box.style.setProperty('--tab-x', (b.left - p.left) + 'px');
        box.style.setProperty('--tab-w', b.width + 'px');
        box.style.setProperty('--tab-h', Math.max(0, p.top - (b.top + b.height / 2)) + 'px');
      }
      if (item) new MutationObserver(function () {
        var on = item.classList.contains('is-open');
        if (on && !box.dataset.open) {
          box.dataset.open = '1';
          placeTab();
          show1(0);
          typeIn(box.querySelector('.cx-casc__col'));
        }
        if (!on) delete box.dataset.open;
      }).observe(item, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', function () { if (box.dataset.open) placeTab(); });
    });

    document.querySelectorAll('[data-cx-mxm]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var item = box.closest('[data-cx-drop]');
      var c1 = box.querySelector('.cx-casc__col');
      var c2 = box.querySelector('[data-mxm-c2]'), c3 = box.querySelector('[data-mxm-c3]');
      var tab = box.querySelector('[data-cx-casc-tab]');
      var base = box.dataset.base, N = null, kids = {}, tipo = '', tipoN = box.dataset.all || 'Todas', cargando = false, t1;
      var CHEV = '<svg class="cx-casc__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';
      var esc = function (t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
      function lab(i) { return N[i][1].replace(/^Seria\b/, 'Serie').replace(/^Klasa\b/, 'Clase'); }
      function url(i) { var p = []; if (i != null) p.push('mx' + i); if (tipo) p.push(tipo); return base + (p.length ? '/' + p.join('+') : ''); }
      function head(t, href) { return '<div class="cx-casc__head"><span>' + esc(t) + '</span><a href="' + href + '">Ver todo</a></div>'; }
      function marcas() {
        if (!N) return;
        c2.innerHTML = head(tipoN + ' · por marca', url(null)) + '<ul class="cx-casc__list" role="list">' + (kids[-1] || []).map(function (i) {
          return '<li class="cx-casc__i2" data-mxm-b="' + i + '"><a class="cx-casc__a2" href="' + url(i) + '">' + esc(lab(i)) + ((kids[i] || []).length ? CHEV : '') + '</a></li>';
        }).join('') + '</ul>';
        c2.scrollTop = 0; c3.innerHTML = '';
        typeIn(c2);
      }
      function modelos(li) {
        var i = +li.getAttribute('data-mxm-b');
        c2.querySelectorAll('[data-mxm-b]').forEach(function (x) { x.classList.toggle('is-active', x === li); });
        var l = kids[i] || [];
        c3.innerHTML = l.length ? head(lab(i), url(i)) + '<ul class="cx-casc__list" role="list">' + l.map(function (m) { return '<li><a class="cx-casc__a3" href="' + url(m) + '">' + esc(lab(m)) + '</a></li>'; }).join('') + '</ul>' : '';
        c3.scrollTop = 0;
        if (l.length) typeIn(c3);
      }
      function cargar() {
        if (N || cargando) return;
        cargando = true;
        c2.innerHTML = '<div class="cx-casc__head"><span>Cargando marcas…</span></div>';
        fetch(box.dataset.src).then(function (r) { return r.json(); }).then(function (d) {
          N = d; N.forEach(function (n, i) { (kids[n[0]] = kids[n[0]] || []).push(i); });
          marcas();
        }).catch(function () { c2.innerHTML = ''; });
      }
      function placeTab() {
        var btn = item.querySelector('.cx-nav__link');
        if (!btn || !tab) return;
        var b = btn.getBoundingClientRect(), p = box.getBoundingClientRect();
        box.style.setProperty('--tab-x', (b.left - p.left) + 'px');
        box.style.setProperty('--tab-w', b.width + 'px');
        box.style.setProperty('--tab-h', Math.max(0, p.top - (b.top + b.height / 2)) + 'px');
      }
      function onEnter(e) {
        var a = e.target.closest('[data-mxm-t]');
        if (a && c1.contains(a)) {
          clearTimeout(t1);
          t1 = setTimeout(function () {
            if (a.classList.contains('is-active') && c2.innerHTML) return;
            c1.querySelectorAll('[data-mxm-t]').forEach(function (x) { x.classList.toggle('is-active', x === a); });
            tipo = a.getAttribute('data-mxm-t'); tipoN = a.getAttribute('data-mxm-n');
            marcas();
          }, e.type === 'focusin' ? 0 : 70);
          return;
        }
        var b = e.target.closest('[data-mxm-b]');
        if (b && c2.contains(b) && !b.classList.contains('is-active')) modelos(b);
      }
      box.addEventListener('mouseover', onEnter);
      box.addEventListener('focusin', onEnter);
      if (item) new MutationObserver(function () {
        var on = item.classList.contains('is-open');
        if (on && !box.dataset.open) {
          box.dataset.open = '1';
          placeTab();
          typeIn(c1);
          if (N) marcas(); else cargar();
        }
        if (!on) delete box.dataset.open;
      }).observe(item, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', function () { if (box.dataset.open) placeTab(); });
    });

    document.querySelectorAll('[data-cx-mll]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var item = box.closest('[data-cx-drop]');
      var c1 = box.querySelector('[data-mll-c1]'), c2 = box.querySelector('[data-mll-c2]'), c3 = box.querySelector('[data-mll-c3]');
      var ul = box.querySelector('[data-mll-brands]'), tab = box.querySelector('[data-cx-casc-tab]');
      var tpl = box.querySelector('template[data-mll-acc]');
      var base = box.dataset.base, D = null, cargando = false, t1, porMarca = {};
      var CHEV = '<svg class="cx-casc__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';
      var esc = function (t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
      function head(t, href) { return '<div class="cx-casc__head"><span>' + esc(t) + '</span><a href="' + href + '">Ver todo</a></div>'; }
      function populares() {
        if (!D) return;
        var top = D.b.slice().sort(function (a, b) { return b[2] - a[2]; }).slice(0, 14);
        c2.innerHTML = head('Marcas más vendidas', base) + '<ul class="cx-casc__list" role="list">' + top.map(function (b) { return '<li class="cx-casc__i2"><a class="cx-casc__a2" href="' + base + '/ll_marca_' + b[0] + '">' + esc(b[1]) + '<small>' + b[2] + '</small></a></li>'; }).join('') + '</ul>';
        c3.innerHTML = ''; typeIn(c2);
      }
      function marca(li) {
        var i = +li.getAttribute('data-mll-b');
        var b = D.b[i];
        var ms = porMarca[i] || [];
        c2.innerHTML = head(b[1] + ' · modelos', base + '/ll_marca_' + b[0]) + '<ul class="cx-casc__list" role="list">' + ms.map(function (m) {
          var r = m.a === m.z ? m.a + '"' : m.a + '"-' + m.z + '"';
          return '<li class="cx-casc__i2"><a class="cx-casc__a2" href="' + base + '/ll_marca_' + b[0] + '+ll_modelo_' + m.s + '">' + esc(m.n) + '<small>' + r + '</small></a></li>';
        }).join('') + '</ul>';
        c2.scrollTop = 0; c3.innerHTML = ''; typeIn(c2);
      }
      function cargar() {
        if (D || cargando) return;
        cargando = true;
        fetch(box.dataset.src).then(function (r) { return r.json(); }).then(function (d) {
          D = d;
          var tmp = {};
          d.r.forEach(function (r) { var k = r[0] + '|' + r[1]; var m = tmp[k] || (tmp[k] = { b: r[0], s: d.m[r[1]][0], n: d.m[r[1]][1], a: 99, z: 0 }); m.a = Math.min(m.a, r[2]); m.z = Math.max(m.z, r[2]); });
          Object.keys(tmp).forEach(function (k) { var m = tmp[k]; (porMarca[m.b] = porMarca[m.b] || []).push(m); });
          Object.keys(porMarca).forEach(function (b) { porMarca[b].sort(function (x, y) { return x.n.localeCompare(y.n, 'es', { numeric: true }); }); });
          var orden = d.b.map(function (b, i) { return i; }).sort(function (x, y) { return d.b[x][1].localeCompare(d.b[y][1], 'es'); });
          ul.innerHTML = orden.map(function (i) { return '<li class="cx-casc__i1" data-mll-b="' + i + '"><a class="cx-casc__a1" href="' + base + '/ll_marca_' + d.b[i][0] + '">' + esc(d.b[i][1]) + CHEV + '</a></li>'; }).join('');
          populares();
          typeIn(c1);
        }).catch(function () {});
      }
      function placeTab() {
        var btn = item.querySelector('.cx-nav__link');
        if (!btn || !tab) return;
        var b = btn.getBoundingClientRect(), p = box.getBoundingClientRect();
        box.style.setProperty('--tab-x', (b.left - p.left) + 'px');
        box.style.setProperty('--tab-w', b.width + 'px');
        box.style.setProperty('--tab-h', Math.max(0, p.top - (b.top + b.height / 2)) + 'px');
      }
      function onEnter(e) {
        var a = e.target.closest('[data-mll-b]');
        if (a && c1.contains(a)) {
          clearTimeout(t1);
          t1 = setTimeout(function () {
            if (a.classList.contains('is-active') && c2.innerHTML) return;
            c1.querySelectorAll('[data-mll-b]').forEach(function (x) { x.classList.toggle('is-active', x === a); });
            var k = a.getAttribute('data-mll-b');
            if (k === 'acc') { c2.innerHTML = tpl ? tpl.innerHTML : ''; c3.innerHTML = ''; typeIn(c2); }
            else if (k === 'all') populares();
            else if (D) marca(a);
          }, e.type === 'focusin' ? 0 : 70);
        }
      }
      box.addEventListener('mouseover', onEnter);
      box.addEventListener('focusin', onEnter);
      if (item) new MutationObserver(function () {
        var on = item.classList.contains('is-open');
        if (on && !box.dataset.open) {
          box.dataset.open = '1';
          placeTab();
          typeIn(c1);
          if (D) populares(); else cargar();
        }
        if (!on) delete box.dataset.open;
      }).observe(item, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', function () { if (box.dataset.open) placeTab(); });
    });

    document.querySelectorAll('[data-cx-typer]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var pre = el.dataset.prefix || '';
      var list = (el.dataset.phrases || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      var put = function (t) { el.setAttribute('placeholder', t); };
      if (!list.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { put(pre + (list[0] || '')); return; }
      var i = 0, j = 0, del = false;
      function tick() {
        var w = list[i];
        if (!del) {
          j++; put(pre + w.slice(0, j) + '|');
          if (j >= w.length) { del = true; return setTimeout(tick, 1700); }
          return setTimeout(tick, 65);
        }
        j--; put(pre + w.slice(0, j) + '|');
        if (j <= 0) { del = false; i = (i + 1) % list.length; return setTimeout(tick, 350); }
        setTimeout(tick, 30);
      }
      setTimeout(tick, 600);
    });

    (function () {
      var form = document.querySelector('[data-cx-sp]');
      var panel = document.querySelector('[data-cx-sp-panel]');
      var overlay = document.querySelector('[data-cx-sp-overlay]');
      if (!form || !panel || form.dataset.ready) return;
      form.dataset.ready = '1';
      var input = form.querySelector('input[name="q"]');
      var grid = panel.querySelector('[data-cx-sp-grid]');
      var links = panel.querySelector('[data-cx-sp-links]');
      var title = panel.querySelector('[data-cx-sp-title]');
      var ltitle = panel.querySelector('[data-cx-sp-ltitle]');
      var all = panel.querySelector('[data-cx-sp-all]');
      var base = { grid: grid.innerHTML, links: links.innerHTML, title: title.textContent, ltitle: ltitle.textContent, all: all.getAttribute('href') };
      var timer, ctrl, cur = '';
      var ICON_SEARCH = form.querySelector('.cx-searchpill__btn').innerHTML;
      var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var cur$ = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var money = function (v) { var n = Number(v); if (isNaN(n)) return esc(v); try { return n.toLocaleString('es-ES', { style: 'currency', currency: cur$ }); } catch (e) { return n.toFixed(2) + ' ' + cur$; } };
      var sized = function (u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=500'; };
      function open() {
        if (panel.classList.contains('is-open')) return;
        panel.classList.add('is-open');
        overlay && overlay.classList.add('is-open');
      }
      function close() {
        panel.classList.remove('is-open');
        overlay && overlay.classList.remove('is-open');
      }
      function reset() {
        grid.innerHTML = base.grid; links.innerHTML = base.links;
        title.textContent = base.title; ltitle.textContent = base.ltitle; all.setAttribute('href', base.all); all.textContent = 'Ver todos';
      }
      function card(p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        return '<div class="cx-sp-card"><a class="cx-sp-card__img" href="' + esc(p.url) + '" tabindex="-1">' + (img ? '<img src="' + esc(sized(img)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="cx-sp-card__info"><a class="cx-sp-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="cx-sp-card__price">' + money(p.price) + '</span></div>' +
          '<a class="cx-sp-card__add" href="' + esc(p.url) + '" aria-label="Ver producto"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div>';
      }
      function search(q) {
        cur = q;
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = form.dataset.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined }).then(function (r) { return r.json(); }).then(function (data) {
          if (q !== cur) return;
          var res = (data && data.resources && data.resources.results) || {};
          var prods = (res.products || []).slice(0, 3);
          var cols = res.collections || [];
          var qs = res.queries || [];
          var full = form.dataset.search + '?type=product&q=' + encodeURIComponent(q);
          title.textContent = 'Resultados para «' + q + '»';
          all.setAttribute('href', full); all.textContent = 'Ver todos los resultados';
          grid.innerHTML = prods.length ? prods.map(card).join('') : '<p class="cx-sp-empty">No hemos encontrado nada para «' + esc(q) + '». Prueba con otra palabra.</p>';
          var items = cols.slice(0, 6).map(function (c) { return { url: c.url, text: c.title.split(' / ').pop() }; });
          if (!items.length) items = qs.slice(0, 6).map(function (c) { return { url: c.url, text: c.text }; });
          if (items.length) {
            ltitle.textContent = cols.length ? 'Colecciones' : 'Sugerencias';
            links.innerHTML = items.map(function (it) { return '<li><a class="cx-sp-link" href="' + esc(it.url) + '">' + ICON_SEARCH + '<span>' + esc(it.text) + '</span></a></li>'; }).join('');
          } else { links.innerHTML = base.links; ltitle.textContent = base.ltitle; }
        }).catch(function () {});
      }
      input.addEventListener('focus', open);
      input.addEventListener('click', open);
      input.addEventListener('input', function () {
        open();
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { cur = ''; if (ctrl) ctrl.abort(); reset(); return; }
        timer = setTimeout(function () { search(q); }, 220);
      });
      form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
      overlay && overlay.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) { close(); input.blur(); } });
      document.addEventListener('click', function (e) { if (!panel.classList.contains('is-open')) return; if (form.contains(e.target) || panel.contains(e.target)) return; close(); });
      panel.addEventListener('submit', function () { setTimeout(close, 50); });
    })();

    if (window.cxCoilReady) return;
    window.cxCoilReady = true;
    function bump() {
      document.querySelectorAll('.cx-coil').forEach(function (svg) {
        svg.classList.remove('is-bump');
        void svg.getBoundingClientRect();
        svg.classList.add('is-bump');
        clearTimeout(svg._cxT);
        svg._cxT = setTimeout(function () { svg.classList.remove('is-bump'); }, 1000);
      });
    }
    window.cxCoilBump = bump;
    var html = document.documentElement, holdT;
    function hold(ms) {
      if (ms <= 0) return;
      html.classList.add('cx-coil-wait');
      clearTimeout(holdT);
      holdT = setTimeout(function () { html.classList.remove('cx-coil-wait'); }, ms);
    }
    function setup() {
      var counter = document.querySelector('.cx-actions [data-cx-cart-count]');
      var drawer = document.querySelector('[data-cx-drawer="cart"]');
      if (!counter) return;
      var last = parseInt(counter.textContent, 10) || 0;
      var incAt = 0, WAIT = 900;
      var mo = new MutationObserver(function (recs) {
        var opened = false;
        recs.forEach(function (r) {
          if (drawer && r.target === drawer && r.attributeName === 'class') {
            if ((r.oldValue || '').indexOf('is-open') === -1 && drawer.classList.contains('is-open')) opened = true;
          }
        });
        var n = parseInt(counter.textContent, 10) || 0;
        var inc = n > last;
        last = n;
        var now = Date.now();
        if (inc) {
          var wasOpen = drawer && drawer.classList.contains('is-open') && !opened;
          bump();
          incAt = now;
          if (opened) hold(WAIT);
          else if (wasOpen) incAt = 0;
        } else if (opened && now - incAt < WAIT) {
          hold(WAIT - (now - incAt));
        }
      });
      mo.observe(counter, { childList: true, characterData: true, subtree: true });
      if (drawer) mo.observe(drawer, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  })();
